import type { LeaderboardMetric } from "@expert/app-config/types";
import type { KyInstance } from "ky";

import { getLeaderboardTimeframe } from "./getLeaderboardTimeframe";

export interface LeaderboardEntry {
    employeeId: string;
    employeeName: string;
    score: number;
    order: number;
}

export const getCurrentLeaderboard = async (
    client: KyInstance,
    metric: LeaderboardMetric,
    sku?: string,
): Promise<LeaderboardEntry[]> => {
    const { start, end } = getLeaderboardTimeframe();
    const searchParams: Record<string, string> = { start, end };
    if (sku) searchParams.productSku = sku;

    return await client.get(`v2/leaderboards/${metric}`, { searchParams, retry: 0 }).json<LeaderboardEntry[]>();
};
